import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent, IsDefinedNotEmptyPipe, ModalService } from '@softline/ui-core';
import { Palette } from '../../types/palette';
import { Lagerplatz } from '../../types/lagerplatz';
import { ArtikelMenge } from '../../types/artikel-menge';
import { isDefinedNotEmpty } from '@softline/core';
import { PalletItemListModalComponent } from '../../dialogs/pallet-item-list/pallet-item-list-modal.component';

@Component({
  selector: 'soft-mixed-pallet',
  imports: [CommonModule, IconComponent, IsDefinedNotEmptyPipe],
  templateUrl: './mixed-pallet.component.html',
  styleUrl: './mixed-pallet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MixedPalletComponent {
  private modalService = inject(ModalService);

  pallet = input<Palette>();
  items = input<ArtikelMenge[]>();
  stockyard = input<Lagerplatz>();

  async openInfoModal(): Promise<void> {
    await this.modalService.open({
      title: 'Mischpaletten Info',
      component: PalletItemListModalComponent,
      data: {
        items: this.items(),
        pallet: this.pallet(),
      },
    });
  }

  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;
}
